import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";
import { AssignModalZIndex } from "@/view/AssignModal/AssignModal.style";

const { ui } = constants.colors;
const { textSObj } = typographyStyles;

export const activityPanelContainerCss: CSSObject = {
  marginTop: "24px",
  paddingTop: "24px",
  borderTop: `1px solid ${ui.neutral[200]}`,
};

export const activityPanelHeaderCss = {
  ...textSObj,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "16px",

  h3: {
    margin: 0,
    color: ui.neutral[700],
    fontSize: "18px",
    fontWeight: 600,
  },
};

export const activityPanelToggleCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  marginBottom: "16px",
  gap: "4px",

  "&:last-child": {
    marginBottom: 0,
  },
};

export const disabledToggleCss: CSSObject = {
  opacity: 0.4,
  pointerEvents: "none",
};

export const tooltipIconCss: CSSObject = {
  width: "16px",
  height: "16px",
  color: ui.neutral[600],
};

export const tooltipCss = {
  body: {
    lineHeight: "1.0",
    maxWidth: "300px",
    fontSize: "14px",
    "@media(min-width: 569px)": {
      fontSize: "16px",
      lineHeight: 1.4,
    },
    ...typographyStyles.fontFamily.circular,
  },
  root: {
    zIndex: AssignModalZIndex + 1,
  },
};
